import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import {
  Grid,
  Skeleton,
  VerticalBox,
} from "@inductiveautomation/ws-components";

import { ProfileFormProps } from "./Profile.types";
import ProfileFormLoading from "./Profile.Form.loading";
import { useMutations } from "./hooks/useMutations";
import ProfileTextField from "./fields/Profile.TextField";
import ProfilePhoneField from "./fields/Profile.PhoneField";
import ProfileCountryField from "./fields/Profile.CountryField";

const ProfileForm = ({ defaultValues, loading }: ProfileFormProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "profile" });

  const { updateProfileField } = useMutations();

  return loading ? (
    <ProfileFormLoading />
  ) : (
    <VerticalBox gap="1.5rem">
      <Grid container spacing="1rem">
        <Grid size={{ xs: 12, sm: 6 }}>
          <ProfileTextField
            defaultValue={defaultValues.firstName ?? ""}
            name="firstName"
            label={t("form.labels.first_name")}
            updateProfileField={updateProfileField}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <ProfileTextField
            defaultValue={defaultValues.lastName ?? ""}
            name="lastName"
            label={t("form.labels.last_name")}
            updateProfileField={updateProfileField}
          />
        </Grid>
      </Grid>

      <Suspense fallback={<Skeleton variant="form_field" />}>
        <ProfilePhoneField phoneNumber={defaultValues.phoneNumber} />
      </Suspense>

      <ProfileTextField
        defaultValue={defaultValues.jobTitle ?? ""}
        name="jobTitle"
        label={t("form.labels.job_title")}
        updateProfileField={updateProfileField}
        allowBlank
      />

      <Suspense fallback={<Skeleton variant="form_field" />}>
        <ProfileCountryField defaultValue={defaultValues.country} />
      </Suspense>
    </VerticalBox>
  );
};

export default ProfileForm;
